module.exports = __webpack_public_path__ + "components/MapControl/svg/Muzeum.svg?8b98c48a";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Muzeum.svg
// module id = 2060
// module chunks = 0